var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.$style.component }, [
    _c(
      "div",
      {
        directives: [{ name: "responsive", rawName: "v-responsive" }],
        staticClass: "bar no-border",
        class: _vm.$style.bar,
      },
      [
        _c(
          "div",
          { class: _vm.$style.title, attrs: { "data-icon-before": "store" } },
          [_vm._v(" Manage Locations ")]
        ),
        _c("div", { class: _vm.$style.controls }, [
          _vm.locations && _vm.locations.length
            ? _c(
                "button",
                {
                  staticClass: "aBtn atDark asLarge",
                  attrs: { "data-icon": "download" },
                  on: { click: _vm.downloadLocations },
                },
                [_vm._v(" Download Locations ")]
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "aBtn atDark asLarge",
              attrs: { "data-icon": "upload" },
              on: { click: _vm.uploadLocations },
            },
            [_vm._v(" Upload Locations ")]
          ),
        ]),
      ]
    ),
    _c(
      "div",
      { class: _vm.$style.list },
      [
        _vm.loading
          ? _c(
              "div",
              { class: _vm.$style.NoLocationsNotification },
              [_c("RbvLoading")],
              1
            )
          : _vm.locations && _vm.locations.length
          ? _c("rbVirtualListFS", {
              attrs: { items: _vm.locations, "item-height": 45 },
              scopedSlots: _vm._u([
                {
                  key: "heading",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { class: _vm.$style.headingRow },
                        [
                          _vm._l(_vm.columns, function (column) {
                            return [
                              _c(
                                "div",
                                {
                                  key: column.id,
                                  class: _vm.$style.headingCell,
                                  style: column.style,
                                },
                                [_vm._v(" " + _vm._s(column.text) + " ")]
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c(
                        "div",
                        { class: _vm.$style.row },
                        [
                          _vm._l(_vm.columns, function (column) {
                            return [
                              _c(
                                "div",
                                {
                                  key: column.id,
                                  class: _vm.$style.cell,
                                  style: column.style,
                                },
                                [_vm._v(" " + _vm._s(column.print(row)) + " ")]
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]
                  },
                },
              ]),
            })
          : _c("div", { class: _vm.$style.NoLocationsNotification }, [
              _c("div", [_vm._v("No locations loaded yet.")]),
              _c(
                "button",
                {
                  staticClass: "aBtn asMain atDark asLarge",
                  attrs: { "data-icon": "upload" },
                  on: { click: _vm.uploadLocations },
                },
                [_vm._v(" Upload Locations ")]
              ),
            ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }